import { Calendar, Clock, MapPin, BookOpen } from 'lucide-react';

export const EventCard = ({ 
  title, 
  date, 
  time, 
  location, 
  description,
  sermonTitle,
  sermonScripture,
  featured = false 
}) => {
  return (
    <div 
      className={`rounded-xl p-6 transition-all duration-300 hover:shadow-lg ${
        featured 
          ? 'bg-primary-900 text-white border-l-4 border-secondary' 
          : 'bg-white border border-slate-100 hover:border-secondary'
      }`}
      data-testid={`event-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex flex-col md:flex-row md:items-start gap-4">
        {/* Date Badge */}
        <div className={`flex-shrink-0 w-16 h-16 rounded-xl flex flex-col items-center justify-center ${
          featured ? 'bg-secondary text-white' : 'bg-secondary/10 text-secondary'
        }`}>
          <span className="text-xs font-semibold uppercase">{date.split(' ')[0]}</span>
          <span className="text-2xl font-bold">{date.split(' ')[1]}</span>
        </div>

        {/* Content */}
        <div className="flex-1">
          <h3 className={`font-heading text-lg font-semibold mb-2 ${
            featured ? 'text-white' : 'text-primary-900'
          }`}>
            {title}
          </h3>
          
          <div className="flex flex-wrap gap-4 mb-3 text-sm">
            <div className={`flex items-center gap-1.5 ${featured ? 'text-slate-300' : 'text-slate-500'}`}>
              <Clock className="w-4 h-4" />
              {time}
            </div>
            {location && (
              <div className={`flex items-center gap-1.5 ${featured ? 'text-slate-300' : 'text-slate-500'}`}>
                <MapPin className="w-4 h-4" />
                {location}
              </div>
            )}
          </div>

          {/* Sermon Info */}
          {(sermonTitle || sermonScripture) && (
            <div className={`flex items-start gap-2 mb-3 p-2 rounded-lg ${
              featured ? 'bg-white/10' : 'bg-blue-50'
            }`}>
              <BookOpen className={`w-4 h-4 mt-0.5 flex-shrink-0 ${featured ? 'text-secondary' : 'text-blue-600'}`} />
              <div className="text-sm">
                {sermonTitle && (
                  <p className={`font-medium ${featured ? 'text-white' : 'text-blue-900'}`}>
                    {sermonTitle}
                  </p>
                )}
                {sermonScripture && (
                  <p className={featured ? 'text-slate-300' : 'text-blue-600'}>
                    {sermonScripture}
                  </p>
                )}
              </div>
            </div>
          )}
          
          {description && (
            <p className={`text-sm leading-relaxed ${featured ? 'text-slate-300' : 'text-slate-600'}`}>
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export const EventList = ({ events, title = "Upcoming Events" }) => {
  return (
    <div data-testid="event-list">
      {title && (
        <h2 className="font-heading text-3xl md:text-4xl font-semibold text-primary-900 mb-8">
          {title}
        </h2>
      )}
      <div className="space-y-4">
        {events.map((event, index) => (
          <EventCard key={`event-list-${event.title}-${event.date}-${index}`} {...event} featured={index === 0} />
        ))}
      </div>
    </div>
  );
};
